import type { IContainer } from '@monofe/di';
import { useKVStorage } from '@monofe/util';
import { useCallback, useState } from 'react';

function useExpandedItemIndex(
    identifier: string,
    container: IContainer,
): [number | null, (index: number | null) => void] {
    const [state, setState] = useState<number | null>(null);
    const storage = useKVStorage(container);

    if (storage && state === null) {
        storage
            .getItem(identifier)
            .then(result => {
                const newNumber = Number.parseInt(String(result) || '-1', 10);
                setState(Number.isSafeInteger(newNumber) ? newNumber : null);
            })
            .catch(error => {
                setState(null);
            });
    }

    const setIndex = useCallback(
        (index: number | null) => {
            setState(index);
            storage?.setItem(identifier, index);
        },
        [setState, storage, identifier],
    );

    return [state, setIndex];
}

export default useExpandedItemIndex;
